<template>
  <div class="select-charts-card card-border">

    
    <div class="card-content">
      <div class="charts-row">
        <select 
          id="chart-group-select"
          :value="group"
          @change="(e) => {
            emit('update:group', e.target.value);
            if (e.target.value) emit('switch-tab', 'charts');
          }"
          class="group-select"
        >
          <option value="">-- Select Chart group --</option>
          <option 
            v-for="group in chartGroups"
            :key="group"
            :value="group"
          >
            {{ group }}
          </option>
        </select>
        
        <button
          class="icon-btn"
          :disabled="!group"
          @click="() => {
            emit('switch-tab', 'charts');
            emit('reload-charts');
          }"
          title="Reload Charts"
        >
          <img src="@/assets/img/chart_multiple.svg" alt="Charts" class="icon" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  taskId: {
    type: Number,
    default: null,
  },
  chartGroups: {
    type: Array,
    default: () => ['train', 'validation', 'test'],
  },
  group: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:group', 'switch-tab', 'reload-charts']);


</script>

<style lang="scss" scoped>
.select-charts-card {
  display: flex;
  flex-direction: column;
  height: fit-content;
  width: 100%;
  max-width: 400px;
}

.card-content {
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.charts-row {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}

.group-select {
  flex: 1;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  @include themify() {
    color: themed('body-text-color');
    border-color: themed('border-color');
    background: themed('input-background');
  }

  &:focus {
    outline: none;
    border-color: #2196f3;
  }
}

.icon-btn {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @include themify() {
    border-color: themed('border-color');
  }

  &:hover:not(:disabled) {
    background: #f0f0f0;
    @include themify() {
      background: themed('hover-background');
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: transparent;
  }

  .icon {
    width: 22px;
    height: 22px;
    display: block;
  }
}
</style>
